module.exports = __webpack_public_path__ + "fc7ee633895cf65b038bfc441d7934ca.svg";